import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './virtual-fence-polygon.reducer';

export const VirtualFencePolygonDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const entity   = useAppSelector(state => state.virtualFencePolygon.entity);
  const updating = useAppSelector(state => state.virtualFencePolygon.updating);
  const updateSuccess = useAppSelector(state => state.virtualFencePolygon.updateSuccess);

  const handleClose = () => {
    props.history.push('/virtual-fence-circle' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    if (entity?.id) {
      dispatch(deleteEntity(entity.id));
    }
  };

  return (
    <Modal isOpen toggle={handleClose} centered>
      <ModalHeader toggle={handleClose} data-cy="virtualFencePolygonDeleteDialogHeading">
        Confirmar exclusão
      </ModalHeader>
      <ModalBody>
        <p>
          Tem certeza que deseja excluir a cerca poligonal <strong>{entity?.name || `#${entity?.id}`}</strong>?
        </p>
        <p className="text-muted small">
          A exclusão será efetivada após a confirmação do equipamento. O item ficará visível com status
          pendente até o hardware confirmar.
        </p>
      </ModalBody>
      <ModalFooter style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <Button color="secondary" onClick={handleClose} disabled={updating} style={{ whiteSpace: 'nowrap' }}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;Cancelar
        </Button>
        <Button
          id="app-confirm-delete-virtualFencePolygon"
          data-cy="entityConfirmDeleteButton"
          color="danger"
          onClick={confirmDelete}
          disabled={updating}
          style={{ whiteSpace: 'nowrap', minWidth: '170px' }}
        >
          <FontAwesomeIcon icon="trash" />
          &nbsp;Solicitar Exclusão
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default VirtualFencePolygonDeleteDialog;
